<template>
  <div>
    <b-navbar class="shadow" toggleable="lg" fixed="top">

      <b-container>

        <b-navbar-brand href="#" class="py-0">
          <img src="@/assets/logo-desktop.png" class="logo-img" />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse">

          <template #default="{ expanded }">
            <div id="nav-icon4" class="mt-2 mx-auto" :class="{ open: expanded }">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

          <b-navbar-nav class="ms-auto">

            <b-nav-item to="/">HOME</b-nav-item>
            <b-nav-item to="/services">SERVICES</b-nav-item>
            <b-nav-item href="#">ABOUT</b-nav-item>
            <b-nav-item href="#">CONTACT</b-nav-item>

          </b-navbar-nav>

        </b-collapse>

      </b-container>

    </b-navbar>

    <router-view class="router-view"></router-view>

    <footer class="footer-59391">
      <b-container>

        <b-row class="mb-5">

          <b-col class="col-auto">
            <div class="logo-img">
              <img src="@/assets/leaf-logo.png" />
            </div>
          </b-col>

          <b-col class="site-logo">
            <p class="mt-3">MONSTERA WEB DESIGN</p>
          </b-col>

          <b-col sm="12" class="contact-info d-flex">
            <div class="ms-auto text-align-right">
              <p>GRAND RAPIDS, MI 49534 USA</p>
              <p>800-555-5555</p>
              <p>info@monsterawebdesign.com</p>
            </div>
          </b-col>

          <!-- <b-col class="col-md-8 d-flex">
            <ul class="list-unstyled social-icons ms-auto d-flex">
              <li><a href="#" class="fb"><span class="icon-facebook"></span></a></li>
              <li><a href="#" class="tw"><span class="icon-twitter"></span></a></li>
              <li><a href="#" class="in"><span class="icon-instagram"></span></a></li>
              <li><a href="#" class="be"><span class="icon-behance"></span></a></li>
              <li><a href="#" class="dr"><span class="icon-dribbble"></span></a></li>
              <li><a href="#" class="yt"><span class="icon-play"></span></a></li>
            </ul>
          </b-col> -->

        </b-row>

        <b-row class="mb-5">

          <b-col class="d-flex">
            <ul class="d-flex mx-auto nav-links list-unstyled nav-right">
              <li><a href="#">HOME</a></li>
              <li><a href="#">SERVICES</a></li>
              <li><a href="#">ABOUT</a></li>
              <li><a href="#">CONTACT</a></li>
            </ul>
          </b-col>

        </b-row>

        <b-row>
          <b-col>
            <div class="copyright">
              <p><small>Copyright 2022. All Rights Reserved.</small></p>
            </div>
          </b-col>
        </b-row>

      </b-container>
    </footer>

  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
body {
  font-family: "Poppins" !important;
}

.navbar {
  background: #247066;
}

img {
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}

@media screen and (max-width: 768px) {
  .logo-img {
    height: 55px;
  }
}

.router-view {
  padding-top: 101px;
}

@media screen and (max-width: 768px) {
  .router-view {
    padding-top: 71px;
  }
}

.nav-item {
  margin-left: 1rem;
  margin-right: 1rem;
  white-space: nowrap;
}

.nav-link {
  font-size: 14pt;
  color: white !important;
}

.nav-link:hover {
  border-bottom: 2px solid;
  border-bottom-color: rgba(224, 246, 234, 0.65)
}

.router-link-exact-active {
  border-bottom: 2px solid;
  border-bottom-color: rgb(224, 246, 234)
}

#nav-icon4 {
  width: 30px;
  height: 30px;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
}

#nav-icon4 span {
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 9px;
  opacity: .9;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

#nav-icon4 span:nth-child(1) {
  top: 0px;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

#nav-icon4 span:nth-child(2) {
  top: 8px;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

#nav-icon4 span:nth-child(3) {
  top: 16px;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

#nav-icon4.open span:nth-child(1) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  top: -1px;
  left: 4px;
}

#nav-icon4.open span:nth-child(2) {
  width: 0%;
  opacity: 0;
}

#nav-icon4.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  top: 20px;
  left: 4px;
}




.footer-59391 {
  border-top: 1px solid #efefef;
  background-color: #247066;
  color: #fff;
  padding: 4rem 0;
}

.footer-59391 .site-logo {
  color: #fff;
}

.footer-59391 .site-logo a {
  font-size: 30px;
  font-weight: 900;
}


@media screen and (max-width: 767px) {
  .site-logo p {
    text-align: right !important;
  }
}

.contact-info p {
  margin-bottom: .5rem;
  text-align: right;
}

.footer-59391 .social-icons li {
  display: inline-block;
}

.footer-59391 .social-icons li a {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.footer-59391 .social-icons li a.dr {
  background: #ff2e6e;
}

.footer-59391 .social-icons li a.be {
  background: #394cff;
}

.footer-59391 .social-icons li a.tw {
  background: #00a0fb;
}

.footer-59391 .social-icons li a.in {
  background: #c31574;
}

.footer-59391 .social-icons li a.fb {
  background: #3b579b;
}

.footer-59391 .social-icons li a.yt {
  background: #fa2614;
}

.footer-59391 .social-icons li a span {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: #fff;
}

.footer-59391 .nav-links li {
  display: inline-block;
}

.footer-59391 .nav-links li a {
  font-size: 14px;
  color: #fff;
  padding: 10px;
}

@media (max-width: 1199.98px) {
  .footer-59391 .nav-links.nav-left li:first-child a {
    padding-left: 0;
  }
}

.footer-59391 .nav-links.nav-right li:last-child a {
  padding-right: 0;
}

@media (max-width: 1199.98px) {
  .footer-59391 .nav-links.nav-right li:first-child a {
    padding-left: 0;
  }
}

.footer-59391 .copyright {
  border-top: 1px solid #efefef;
  padding-top: 50px;
  text-align: center;
  color: #fff;
}
</style>  